import { Worker, array_remove } from "../util";
import angular from "angular";
import moment from "moment";
import Translate from "../Translate";
import Toastr from "../util/Toastr";
export default class ForecastRulesCtrl {
  static $inject = ["ForecastRulesService", "$window"];
  constructor(ForecastRulesService, $window) {
    console.log("forecastrule", arguments);
    this.ForecastRulesService = ForecastRulesService;
    this.$window = $window;
    this.statuses = {};
    this.meterTypes = {
      EE: { A: 0, B: 0, M: 0, C: 0 },
      PLYN: { A: 0, B: 0, S: 0, CM: 0, C: 0 }
    };
    this.updatePeriods = {
      7: "7 dní",
      1: "1 deň"
    };
    this.days = {
      1: "pondělí",
      2: "úterý",
      3: "středa",
      4: "čtvrtek",
      5: "pátek",
      6: "sobota",
      7: "neděle"
    };
    this.monthRule = this.getNewMonthRule();
    this.updateRule = this.getNewUpdateRule();
    this.monthRules = [];
    this.updateRules = [];
    this.selectedRuleId = null;
    this.selectedUpdateRuleId = null;
    this.viewMode = true;
    this.updateViewMode = true;
    this.loadMonthRules();
    this.loadStatuses();
  }

  loadStatuses() {
    this.ForecastRulesService.loadStatuses().then(data => {
      let statuses = {};
      Object.keys(data).forEach(key => {
        statuses["" + data[key].id + ""] = data[key].name;
      });
      statuses["0"] = "Všechny OPM";
      this.statuses = statuses;
    });
  }

  loadMonthRules() {
    this.ForecastRulesService.listMonthRules().then(data => {
      this.monthRules = data;
    });
  }
  deleteMonthRule() {
    if (
      !confirm(
        "Když smažete pravidlo pro měsíční forecast tak současně budou smazána také všechny navazující pravidla pro aktualizaci měsíčního forecastu. Proces je nezvratný. Opravdu chcete smazat toto pravidlo?"
      )
    ) {
      return;
    }
    Toastr.progress();
    this.ForecastRulesService.deleteMonthRule(this.selectedRuleId).then(() => {
      Toastr.notify(Translate.trans("Pravidlo bylo smazáno."), "success");
      this.loadMonthRules();
      this.createNewMonthRule();
      this.viewMode = true;
    });
  }
  getNewMonthRule() {
    return {
      opmList: "",
      commodity: "EE",
      status: "1",
      // by default valid from next month
      validFrom: moment(moment().format("YYYY-MM-01"))
        .add("1", "months")
        .format("YYYY-MM-DD"),
      validTo: "2099-01-01",
      meterType: {
        EE: Object.assign({}, this.meterTypes.EE),
        PLYN: Object.assign({}, this.meterTypes.PLYN)
      },
      consumptionFrom: 1.0,
      consumptionTo: null,
      alertEmail: null,
      forecastEmail: null
    };
  }

  getNewUpdateRule() {
    return {
      opmList: "",
      updatePeriod: "7",
      firstDay: "4",
      blockDays: "6",
      validFrom: moment().format("YYYY-MM-DD"),
      validTo: "2099-01-01"
    };
  }

  selectEditRule(id) {
    this.selectedRuleId = id;
    this.viewMode = true;
    this.ForecastRulesService.getMonthRule(id).then(data => {
      let meterType = JSON.parse(JSON.stringify(this.meterTypes));
      let activeTypes = [];
      if (data.meterType) {
        activeTypes = data.meterType.split(",");
      }
      console.log(data.meterType, meterType, activeTypes);
      activeTypes.forEach(function(val, idx) {
        if (val) {
          meterType[data.commodity][val] = 1;
        }
      });
      console.log(meterType);
      data.meterType = meterType;
      data.opmList = data.opmList || '';
      this.monthRule = data;
    });
    this.loadUpdateRules();
  }

  enableEditMode() {
    this.viewMode = false;
  }
  countExistingMonthRules(commodity) {
    let cnt = 0;
    this.monthRules.forEach(v => {
      if (v.commodity == commodity) {
        cnt++;
      }
    });
    return cnt;
  }
  saveMonthRule(force) {
    let errors = [];
    if (!this.monthRule.alertEmail) {
      errors.push(
        Translate.trans('Pole "Alert poslat na e-mail" musí být vyplněno')
      );
    }
    if (!this.monthRule.forecastEmail) {
      errors.push(
        Translate.trans('Pole "Předpoklad poslat na e-mail" musí být vyplněno')
      );
    }
    if (
      this.countExistingMonthRules(this.monthRule.commodity) > 1 &&
      !this.selectedRuleId
    ) {
      if (
        !confirm(
          Translate.trans(
            "Měli by existovat jen 2 pravidla pro stejnou komoditu. Chcete pokračovat?"
          )
        )
      ) {
        return;
      }
    }
    if (errors.length) {
      Toastr.notify(errors.join("\n"), "danger");
      return;
    }

    let that = this;
    Toastr.progress();
    this.ForecastRulesService.saveMonthRule(
      this.monthRule,
      this.selectedRuleId,
      force
    ).then(data => {
      if (typeof data.errors !== "undefined") {
        if (data.errors[0] == "invalid_opm_detected") {
          if (
            confirm(
              Translate.trans(
                "Niektoré OPM nevyhovujú kritériám, importovať len vyhovujúce?"
              )
            )
          ) {
            that.saveMonthRule(true);
          }
          return;
        }
        Toastr.notify(data.errors.join("\n"), "danger");
      } else {
        Toastr.notify(Translate.trans("Pravidlo bylo uloženo."), "success");
        this.loadMonthRules();
        this.selectedRuleId = null;
        this.viewMode = true;
      }
    });
  }

  createNewMonthRule() {
    this.selectedRuleId = null;
    this.viewMode = false;
    let newRule = this.getNewMonthRule();
    let that = this;
    Object.keys(newRule).forEach(key => {
      that.monthRule[key] = newRule[key];
    });
  }

  showAssignedOPMs(type) {
    this.$window.open(
      "#!/forecast/rules/opms/" +
        type +
        "/" +
        (type == "month" ? this.selectedRuleId : this.selectedUpdateRuleId)
    );
  }

  createNewUpdateRule() {
    this.selectedUpdateRuleId = null;
    this.updateViewMode = false;
    let newRule = this.getNewUpdateRule();
    let that = this;
    Object.keys(newRule).forEach(key => {
      that.updateRule[key] = newRule[key];
    });
  }

  enableUpdateEditMode() {
    this.updateViewMode = false;
  }
  saveUpdateRule(force) {
    let that = this;
    Toastr.progress();
    this.ForecastRulesService.saveUpdateRule(
      this.updateRule,
      this.selectedUpdateRuleId,
      this.selectedRuleId,
      force
    ).then(data => {
      if (typeof data.errors !== "undefined") {
        if (data.errors[0] == "invalid_opm_detected") {
          if (
            confirm(
              Translate.trans(
                "Niektoré OPM nevyhovujú kritériám, importovať len vyhovujúce?"
              )
            )
          ) {
            that.saveUpdateRule(true);
          }
          return;
        }
        Toastr.notify(data.errors.join("\n"), "danger");
      } else {
        Toastr.notify(Translate.trans("Pravidlo bylo uloženo."), "success");
        this.loadUpdateRules();
        this.selectedUpdateRuleId = null;
        this.updateViewMode = true;
      }
    });
  }
  deleteUpdateRule() {
    if (
      !confirm(
        "Když smažete pravidlo pro aktualizaci měsíčního forecastu, tak toto pravidlo už nebude možné obnovit. Opravdu chcete smazat toto pravidlo?"
      )
    ) {
      return;
    }
    this.ForecastRulesService.deleteUpdateRule(this.selectedUpdateRuleId).then(
      () => {
        Toastr.notify(Translate.trans("Pravidlo bylo smazáno."), "success");
        this.loadUpdateRules();
        this.selectedUpdateRuleId = null;
      }
    );
  }
  selectEditUpdateRule(id) {
    this.selectedUpdateRuleId = id;
    this.ForecastRulesService.getMonthUpdateRule(id).then(data => {
      data.firstDay = "" + data.firstDay;
      data.updatePeriod = "" + data.updatePeriod;
      this.updateRule = data;
    });
  }
  loadUpdateRules() {
    this.ForecastRulesService.listMonthUpdateRules(this.selectedRuleId).then(
      data => {
        this.updateRules = data;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/ForecastRules/ForecastRulesCtrl.js